import { setUser } from '@sentry/react';
import { put, select, take } from 'redux-saga/effects';
import { LOAD } from 'redux-storage';

import errorAction from '../actions/error';
import { SESSION_CLEAR } from '../actions/sessionClear';
import { SESSION_SET } from '../actions/sessionSet';
import graphqlClient from '../consumers/graphqlClient';
import ViewerQuery from '../graphql/queries/ViewerQuery';
import selectSessionToken from '../selectors/sessionToken';

export default function* sentrySetSessionSaga() {
  yield take(LOAD);

  while (true) {
    const sessionToken = yield select(selectSessionToken);

    if (sessionToken) {
      try {
        const viewerInfoResponse = yield graphqlClient.query({
          query: ViewerQuery,
        });
        const viewerInfoResult = viewerInfoResponse.data;
        const viewerInfoData = viewerInfoResult.viewer;

        setUser({
          id: viewerInfoData.id,
          email: viewerInfoData.email,
          username: viewerInfoData.username,
        });
      } catch (error) {
        yield put(
          errorAction({
            error,
            title: 'Failed to set sentry session',
            description: error.message,
            suppress: true,
          }),
        );
      }
    }

    yield take([SESSION_CLEAR, SESSION_SET]);
  }
}
